var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_shop",
    "data-name": "vuesax/bulk/shop",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.713.175V3.919A3.126,3.126,0,0,1,8.588,7.044H3.125A3.126,3.126,0,0,1,0,3.919V.219a2.548,2.548,0,0,0,1.881.806A2.558,2.558,0,0,0,3.9,0,2.346,2.346,0,0,0,5.856,1.025,2.334,2.334,0,0,0,7.8.025a2.562,2.562,0,0,0,2,1A2.494,2.494,0,0,0,11.713.175Z",
    transform: "translate(1.644 6.944)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.223,0H.473L.011,4.6A2.43,2.43,0,0,0,.192,5.788a2.335,2.335,0,0,0,2.162,1.4A2.329,2.329,0,0,0,4.523,5.794a2.487,2.487,0,0,0,.188-.9V4.775Z",
    transform: "translate(5.146 0.781)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.531,4.388,5.35,2.656C5.087.769,4.231,0,2.4,0H0L.462,4.688a2.245,2.245,0,0,1,.013.25,2.386,2.386,0,0,0,.287.894A2.591,2.591,0,0,0,3,7.188,2.489,2.489,0,0,0,5.05,6.169,2.545,2.545,0,0,0,5.531,4.388Z",
    transform: "translate(8.444 0.781)",
    fill: "#292d32",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.137,0C1.3,0,.45.769.181,2.675L.012,4.394A2.569,2.569,0,0,0,.525,6.219a2.506,2.506,0,0,0,2.019.969A2.587,2.587,0,0,0,4.775,5.844a2.326,2.326,0,0,0,.3-.944L5.562.006H3.137Z",
    transform: "translate(0.982 0.781)",
    fill: "#292d32",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.394.022A1.559,1.559,0,0,0,0,1.578V3.6H3.594V1.8C3.6.491,2.831-.128,1.394.022Z",
    transform: "translate(5.7 10.39)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H15V15H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.926377126de6950c4fe1313d44119911.svg";
export { ForwardRef as ReactComponent };